import { useState } from 'react';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<
	{
		displayExperiment: boolean;
	},
	{
		setDisplayExperiment: (displayExperiment: boolean) => void;
	}
>;

export const useSavedPaymentMethodExperiment = (): Result => {
	const [{ savedPaymentExperimentVariant }] = usePromotePageState();
	const [displayExperiment, setDisplayExperiment] = useState(
		!!savedPaymentExperimentVariant && savedPaymentExperimentVariant !== 'control',
	);
	const [prevVariant, setPrevVariant] = useState(savedPaymentExperimentVariant);

	// Sync displayExperiment once when the async variant resolves (falsy → truthy)
	if (savedPaymentExperimentVariant !== prevVariant) {
		setPrevVariant(savedPaymentExperimentVariant);
		if (!prevVariant && savedPaymentExperimentVariant) {
			setDisplayExperiment(savedPaymentExperimentVariant !== 'control');
		}
	}

	return {
		data: {
			displayExperiment,
		},
		actions: {
			setDisplayExperiment,
		},
	};
};
